import AssetResearch from "../components/AssetResearch";



const AssetResearchPage = () => {
  return (
    <section className="">
      {/* <TopMenuStrip /> */}
     <AssetResearch/>
    </section>
  );
};

export default AssetResearchPage;